class ShippingEstimator {

  constructor() {

    this.button =
      document.getElementById(
        'EstimateShippingBtn'
      );

    if (!this.button) return;

    this.results =
      document.getElementById(
        'ShippingResults'
      );

    this.delivery =
      document.getElementById(
        'DeliveryEstimate'
      );

    this.country =
      document.getElementById(
        'ShippingCountry'
      );
      this.province =
  document.getElementById(
    'ShippingProvince'
  );

    this.locationInput =
      document.getElementById(
        'ShippingLocation'
      );

    this.zip =
      document.getElementById(
        'ShippingZip'
      );

    this.lookup =
      document.getElementById(
        'PostcodeLookup'
      );

    this.searchSpinner =
      document.querySelector(
        '.shipping-estimator__search-spinner'
      );

    this.variantInput =
      document.querySelector(
        'input[name="id"]'
      );

    this.postcodeData = {};

    this.city = '';
    this.selectedLocation = false;
    this.searchRequestId = 0;

    this.bindEvents();
    this.updateEstimateButtonState();

    if (
  window.google &&
  google.maps &&
  typeof google.maps.importLibrary === 'function'
) {

  this.initGooglePlaces();

}
  }

  setSearchLoading(state) {
    if (!this.searchSpinner) {
      return;
    }

    this.searchSpinner.hidden = !state;
  }

  updateEstimateButtonState() {
    if (!this.button) {
      return;
    }

    const canEstimate =
      !!this.zip.value &&
      !!this.city &&
      !!this.selectedLocation;

    this.button.disabled =
      !canEstimate;
    this.button.setAttribute(
      'aria-disabled',
      String(!canEstimate)
    );
  }

  applyLocationSelection(location) {
    const formattedAddress =
      `${location.suburb}, ${location.state} ${location.postcode}, Australia`;

    this.locationInput.value =
      formattedAddress;
    $('.delivery-to').html(
      formattedAddress
    );
    this.zip.value =
      location.postcode;
    this.city =
      location.suburb;
    this.selectedLocation = true;

    if (this.province) {
      this.province.value =
        location.state;
    }

    this.lookup.textContent =
      `${location.suburb}, ${location.state} ${location.postcode}`;

    this.updateEstimateButtonState();
  }

  bindEvents() {

    this.button.addEventListener(
      'click',
      () => this.calculate()
    );

    document.addEventListener(
      'variant:change',
      () => {
        this.clearResults();
      }
    );
  }

  async initGooglePlaces() {

  try {

    if (window.AU_POSTCODES_URL) {

      try {

        const response = await fetch(
          window.AU_POSTCODES_URL
        );

        if (!response.ok) {
          throw new Error('Unable to load postcode data');
        }

        this.postcodeData = await response.json();

      } catch (error) {

        console.error(
          'Local postcode data failed to load',
          error
        );

      }

    }

    const { AutocompleteSuggestion } =
      await google.maps.importLibrary(
        "places"
      );

    let debounceTimer;

    let dropdown =
      document.getElementById(
        "ShippingSuggestions"
      );

    if (!dropdown) {

      dropdown =
        document.createElement("div");

      dropdown.id =
        "ShippingSuggestions";

      dropdown.className =
        "shipping-suggestions";

      this.locationInput
        .parentNode
        .appendChild(dropdown);

    }

    const clearDropdown = () => {
      dropdown.innerHTML = "";
      dropdown.style.display = "none";
    };

    const showDropdown = () => {
      dropdown.style.display = "block";
    };

    this.locationInput.addEventListener(
      "input",
      (e) => {

        clearTimeout(
          debounceTimer
        );

        const value =
          e.target.value
            .replace(/\D/g, "")
            .slice(0, 4);

        e.target.value = value;

        this.zip.value = "";

        this.city = "";
        this.selectedLocation = false;

        this.lookup.innerHTML = "";
        this.updateEstimateButtonState();

        if (
          value.length < 1
        ) {

          this.setSearchLoading(false);
          clearDropdown();

          return;
        }

        debounceTimer =
          setTimeout(
            async () => {
              const searchId = ++this.searchRequestId;
              this.setSearchLoading(true);

              try {

                const postcodeLocations =
                  this.getMatchingPostcodeLocations(
                    value
                  );

                if (
                  postcodeLocations.length
                ) {
                  if (searchId !== this.searchRequestId) {
                    return;
                  }

                  console.log(
                    'Shipping postcode results',
                    postcodeLocations
                  );

                  if (postcodeLocations.length === 1) {
                    this.applyLocationSelection(
                      postcodeLocations[0]
                    );
                    clearDropdown();
                    this.setSearchLoading(false);
                    await this.calculate();
                    return;
                  }

                  dropdown.innerHTML = "";

                  postcodeLocations.forEach(
                    (
                      location
                    ) => {

                      const button =
                        document.createElement(
                          "button"
                        );

                      button.type = "button";
                      button.className =
                        "shipping-suggestion";
                      button.textContent =
                        `${location.suburb}, ${location.state} ${location.postcode}`;

                      button.addEventListener(
                      "click",
                      async () => {

                          this.applyLocationSelection(
                            location
                          );

                          clearDropdown();
                          this.setSearchLoading(false);

                          await this.calculate();

                        }
                      );

                      dropdown.appendChild(button);

                  }
                );

                  showDropdown();
                  this.setSearchLoading(false);

                  return;

                }

                if (
                  /^\d{3,4}$/.test(
                    value
                  )
                ) {

                  console.error(
                    'No local postcode results found',
                    value
                  );

                }

                const { suggestions } =
                  await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                    input: value,
                    includedRegionCodes: ["au"],
                    includedPrimaryTypes: ["postal_code"]
                  });

                if (searchId !== this.searchRequestId) {
                  return;
                }

                dropdown.innerHTML = "";

                if (
                  !suggestions ||
                  !suggestions.length
                ) {

                  if (searchId === this.searchRequestId) {
                    this.setSearchLoading(false);
                  }
                  clearDropdown();

                  return;
                }
                

                suggestions.forEach(
                  (
                    suggestion
                  ) => {

                    const button =
                      document.createElement(
                        "button"
                      );

                    button.type =
                      "button";

                    button.className =
                      "shipping-suggestion";

                    button.textContent =
                      suggestion.placePrediction
                        .text
                        .text;

                      button.addEventListener(
                      "click",
                      async () => {

                        try {

                          const place =
                            suggestion
                              .placePrediction
                              .toPlace();

                          await place.fetchFields({
                            fields: [
                              "addressComponents",
                              "formattedAddress"
                            ]
                          });

                          let postcode =
                            "";

                          let suburb =
                            "";

                          let state =
                            "";

                          let stateLong =
                            "";

                          (
                            place.addressComponents ||
                            []
                          ).forEach(
                            (
                              component
                            ) => {

                              const types =
                                component.types ||
                                [];

                              if (
                                types.includes(
                                  "postal_code"
                                )
                              ) {

                                postcode =
                                  component.longText;

                              }

                              if (
                                types.includes(
                                  "locality"
                                )
                              ) {

                                suburb =
                                  component.longText;

                              }

                              if (
                                types.includes(
                                  "administrative_area_level_1"
                                )
                              ) {

                                state =
                                  component.shortText;

                                stateLong =
                                  component.longText;

                              }

                            }
                          );

                          this.locationInput.value =
                            place.formattedAddress;
                          $('.delivery-to').html(place.formattedAddress);
                          this.zip.value =
                            postcode;

                          this.city = suburb;

                          if (
                            this.province
                          ) {

                            this.province.value =
                              stateLong;

                          }

                          this.lookup.innerHTML =
                            `
                              ${suburb},
                              ${state}
                              ${postcode}
                            `;
                          this.selectedLocation = true;
                          this.updateEstimateButtonState();

                          clearDropdown();
                          this.setSearchLoading(false);

                          if (
                            postcode
                          ) {

                            await this.calculate();

                          }

                        } catch (
                          error
                        ) {

                          console.error(
                            error
                          );

                        }

                      }
                    );

                    dropdown.appendChild(
                      button
                    );

                  }
                );

                showDropdown();
                this.setSearchLoading(false);

              } catch (
                error
              ) {

                console.error(
                  "Places API Error",
                  error
                );

                if (searchId === this.searchRequestId) {
                  this.setSearchLoading(false);
                }
              }

            },
            500
          );

      }
    );

    document.addEventListener(
      "click",
      (event) => {

        if (
          !event.target.closest(
            ".shipping-location-wrapper"
          )
        ) {

          clearDropdown();

        }

      }
    );

  } catch(error) {

    console.error(
      "Google Places init failed",
      error
    );

  }

}

  getMatchingPostcodeLocations(
    postcode
  ) {

    if (
      !postcode ||
      !/^\d{3,4}$/.test(
        postcode
      )
    ) {
      return [];
    }

    const matchingPostcodes =
      postcode.length === 4
        ? [postcode]
        : Object.keys(this.postcodeData)
          .filter(postcodeKey =>
            postcodeKey.startsWith(
              postcode
            )
          )
          .sort();

    return matchingPostcodes
      .flatMap(postcodeKey =>
        this.getPostcodeLocations(
          this.postcodeData[
            postcodeKey
          ],
          postcodeKey
        )
      );

  }

  getPostcodeLocations(
    postcodeRecord,
    postcode
  ) {

    if (!postcodeRecord) {
      return [];
    }

    if (
      Array.isArray(
        postcodeRecord.locations
      )
    ) {

      return postcodeRecord.locations
        .map(location => ({
          postcode,
          suburb:
            location.suburb ||
            location.locality ||
            location.city ||
            '',
          state:
            location.state ||
            postcodeRecord.state ||
            ''
        }))
        .filter(location =>
          location.suburb &&
          location.state
        );

    }

    if (
      Array.isArray(
        postcodeRecord.suburbs
      )
    ) {

      return postcodeRecord.suburbs
        .map(suburb => ({
          postcode,
          suburb,
          state:
            postcodeRecord.state ||
            ''
        }))
        .filter(location =>
          location.suburb &&
          location.state
        );

    }

    return [];
  }

  setLoading(state) {

    const spinner =
      this.button.querySelector(
        '.btn-spinner'
      );

    const text =
      this.button.querySelector(
        '.btn-text'
      );

    if (state) {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'true');

      this.button.disabled =
        true;

    } else {

      document
  .getElementById('EstimateShippingBtn')
  .setAttribute('aria-busy', 'false');
      this.updateEstimateButtonState();
    }
  }

  clearResults() {

    this.results.innerHTML = '';

    this.delivery.innerHTML = '';
    $('.shipping-estimator').removeClass('show-results');
  }

  async addTempItem(
    variantId
  ) {

    const response =
      await fetch(
        '/cart/add.js',
        {
          method:'POST',
          headers:{
            'Content-Type':
            'application/json'
          },
          body:JSON.stringify({
            id:variantId,
            quantity:1
          })
        }
      );

    return response.json();
  }

  async removeTempItem(
    variantId
  ) {

    const cart =
      await fetch('/cart.js')
      .then(r => r.json());

    const item =
      cart.items.find(
        item =>
          item.variant_id ==
          variantId
      );

    if (!item) return;
const newQty = item.quantity - 1;
    await fetch(
      '/cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
          'application/json'
        },
        body:JSON.stringify({
          id:item.key,
          quantity:newQty
        })
      }
    );
  }

  async fetchRates(
    country,
    province,
    zip,
    city
  ) {

    const params = new URLSearchParams({
      'shipping_address[zip]': zip,
      'shipping_address[country]': country,
      'shipping_address[province]': province,
      'shipping_address[city]': city
    });

    const response =
      await fetch(
        `/cart/shipping_rates.json?${params.toString()}`
      );

    return response.json();
  }

  renderRates(rates) {

    if (!rates.length) {

      this.results.innerHTML =
        'No shipping methods available';

      return;
    }

    let html = '';

    rates.forEach(rate => {

      html += `
        <div class="shipping-rate">

          <div>
            ${rate.name}
          </div>

          <div>
            $${rate.price}
          </div>

        </div>
      `;
    });

    this.results.innerHTML =
      html;
      $('.shipping-estimator').addClass('show-results');
  }

  renderDeliveryEstimate(
    rates
  ) {

    const hasExpress =
      rates.some(rate =>
        rate.name
        .toLowerCase()
        .includes('express')
      );

    this.delivery.innerHTML =
      hasExpress
      ? 'Express delivery available: 2–4 business days'
      : 'Estimated delivery: 5–7 business days';
  }

  async calculate() {

    try {

      const zip =
        this.zip.value;

      if (!zip) {
        return;
      }
      const province =
  this.province.value;

       this.setLoading(true);

      this.clearResults();

      const variantId =
        this.variantInput.value;
      document.documentElement.classList.add(
  'shipping-estimator-running'
);
window.__shippingEstimatorRunning = true;
      await this.addTempItem(
        variantId
      );
      
      const data =
        await this.fetchRates(
          'AU',
          province,
          zip,
          this.city
        );
        
      const rates =
        data.shipping_rates || [];

      this.renderRates(
        rates
      );

      // this.renderDeliveryEstimate(
      //   rates
      // );

      await this.removeTempItem(
        variantId
      );
window.__shippingEstimatorRunning = false;
    } catch(error) {

      console.error(error);

      this.results.innerHTML =
        'Unable to estimate shipping';

    } finally {
       this.setLoading(false);
       document.documentElement.classList.remove(
            'shipping-estimator-running'
          );
          
      
    }
  }
}

window.addEventListener(
  'load',
  () => {

    const waitForGoogle = () => {

      if (
        window.google &&
        google.maps &&
        typeof google.maps.importLibrary === 'function'
      ) {

        new ShippingEstimator();

      } else {

        setTimeout(
          waitForGoogle,
          200
        );

      }

    };

    waitForGoogle();

  }
);

(function() {

  const originalDispatch =
    document.dispatchEvent;

  document.dispatchEvent =
    function(event) {

      if (
        document.documentElement.classList.contains(
          'shipping-estimator-running'
        ) &&
        event.type === 'rebuy:cart.change'
      ) {
        console.log(
          'Blocked rebuy:cart.change'
        );
        return true;
      }

      return originalDispatch.call(
        this,
        event
      );
    };

})();
